<atlas-modal
	#atlasModal
	[attr.header]="header"
	[attr.size]="size"
	[attr.header-logo]="headerLogo"
	[attr.header-img]="headerImg"
	[attr.header-illustration]="headerIllustration"
	[attr.header-img-description]="headerImgDescription"
	[attr.skeleton-loading]="skeletonLoading || null"
	[attr.disable-auto-close]="disableAutoClose || null"
	destroy-on-close="true"
	open=""
	(atlas-modal-close)="closeModal()"
>
	<atlas-layout gap="6">
		<ng-container *ngIf="title && !isHighRisk">
			<atlas-heading alignment="center" size="h5">
				{{ title | translate }}
			</atlas-heading>
		</ng-container>

		<atlas-text
			[attr.alignment]="bodyAligment"
			[muted]="bodyMuted"
			[innerHTML]="body | translate"
		>
		</atlas-text>

		@if (youtubeSrc) {
			<div class="d-flex justify-content-center">
				<youtube-player
					#player
					[width]="youtubeScreenWidth"
					[height]="youtubeScreenHeight"
					[videoId]="youtubeSrc"
					(stateChange)="onPlayerStateChange($event)"
				/>
			</div>
		}

		<div class="form-check" *ngIf="isHighRisk">
			<input
				id="checkHighRisk"
				type="checkbox"
				class="form-check-input"
				(click)="changeStateBtnDeleteHighRisk($event.target)"
			/>
			<label for="checkHighRisk" class="form-label">
				{{ "GLOBAL.MODAL_DELETE_HIGH_RISK.TEXT_CHECKBOX" | translate }}
			</label>
		</div>
	</atlas-layout>

	@for (button of buttons; track button) {
		<atlas-button
			[type]="button?.type || 'filled'"
			[description]="button?.description || '' | translate"
			[theme]="button?.theme"
			[size]="button?.size"
			[disabled]="button?.disabled || isDisabledBtnDeleteHighRisk"
			[block]="button?.block"
			[pill]="button?.pill"
			[loading]="button.isConfirm ? (loading$ | async) : false"
			[icon]="button.icon"
			[href]="button.href"
			[attr.is-external-link]="button['is-external-link']"
			[attr.show-badge]="button['show-badge']"
			[attr.badge-number]="button['badge-number']"
			[attr.skeleton-loading]="button['skeleton-loading']"
			slot="actions"
			(click)="handleClick($event, button)"
		></atlas-button>
	}
</atlas-modal>
